import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-ondemand-time',
  templateUrl: './ondemand-time.component.html',
  styleUrls: ['./ondemand-time.component.css']
})
export class OndemandTimeComponent implements OnInit {
  @Input() tiempoEspera: any = {};

  private routerSub!: Subscription;

  msjTittleTurno: string = '';
  mensajeSubTittleTurno: string = '';
  idStatusConsulta: number = 0;
  urlActual: string = '';
  isLoading: boolean = true;

  constructor(private router: Router,
  ) { }

  ngOnInit(): void {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.setMensajeBanner(event.urlAfterRedirects);
      });

    this.setMensajeBanner();
  }


  setMensajeBanner(urlActual?: string){
    this.urlActual = urlActual || this.router.url;
    this.idStatusConsulta = this.tiempoEspera.consulta.sta_id

    if(this.urlActual.includes('dashboard')){
      this.msjTittleTurno = '¡Ya es tu turno!';
      this.mensajeSubTittleTurno = 'Dirígete a la sala espera';
    }else if(this.urlActual.includes('mivideoconsulta')){
      this.msjTittleTurno = '¡Ya estás en atención!';
      this.mensajeSubTittleTurno = '';
    }else if(this.urlActual.includes('salaespera')){
      this.msjTittleTurno = '¡Ya es tu turno!';
      this.mensajeSubTittleTurno = 'Espera a ser atendido';
    }else{
      this.msjTittleTurno = '¡Ya es tu turno!';
      this.mensajeSubTittleTurno = 'Dirígete a la sala espera.';
    }

    //this.isLoading = false;
    this.isLoading = false;

    /*
    if(this.idStatusConsulta == 120){
      this.msjTittleTurno = '¡Ya es tu turno!';
      this.mensajeSubTittleTurno = 'Espera a tu médico.';
    }else if(this.idStatusConsulta == 116){
      this.msjTittleTurno = 'Ya estas en atención.';
      this.mensajeSubTittleTurno = '¡Ingresa a la videollamada!';
    }
    */
  }

  redondearTiempo(tiempo: number): string {
    const tiempoRedondeado = Math.round(tiempo);
  
    if (tiempoRedondeado > 60) {
      return '+60';
    }
  
    return `${Math.max(tiempoRedondeado, 5)}`;
  }

  redirectToSalaEspera() {
    let url = `salaespera/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.tel_doc_app_boo_id}/${this.tiempoEspera.consulta.med_con_id}`;
    this.router.navigate([url]);


  }

  redirectToFilaEspera(){
    let url = `fila-ondemand/${this.tiempoEspera.consulta.tel_doc_od_id}/${this.tiempoEspera.consulta.tel_doc_od_id}`;
    this.router.navigate([url]);

  }

}
